import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
  {
    key: "error-page-1",
    path: `${AUTH_PREFIX_PATH}/error-page-1`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-1")),
  },
  {
    key: "error-page-2",
    path: `${AUTH_PREFIX_PATH}/error-page-2`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-2")),
  },
];

export const protectedRoutes = [
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() => import("views/app-views/dashboards")),
  },
  {
    key: "modules.inventory",
    path: `${APP_PREFIX_PATH}/modules/labs`,
    component: React.lazy(() => import("views/app-views/apps/labs")),
  },
  {
    key: "modules.inventory",
    path: `${APP_PREFIX_PATH}/modules/inventory/racks`,
    component: React.lazy(() => import("views/app-views/apps/inventory/racks")),
  },
  {
    key: "modules.inventory",
    path: `${APP_PREFIX_PATH}/inventory/racks/:id`,
    component: React.lazy(() => import("views/app-views/apps/inventory/racks/RackDetails")),
  },
  {
    key: "modules.labs.list",
    path: `${APP_PREFIX_PATH}/modules/labs/list`,
    component: React.lazy(() => import("views/app-views/apps/labs")),
  },
  {
    key: "modules.labs.templates",
    path: `${APP_PREFIX_PATH}/modules/labs/templates`,
    component: React.lazy(() => import("views/app-views/apps/labs/testtemplates")),
  },
  {
    key: "modules.labs.test",
    path: `${APP_PREFIX_PATH}/modules/labs/labtests`,
    component: React.lazy(() => import("views/app-views/apps/labs/labtest")),
  },
  {
    key: "modules.lab",
    path: `${APP_PREFIX_PATH}/modules/lab/:id`,
    component: React.lazy(() => import("views/app-views/apps/labs/category")),
  },
  {
    key: "modules.labs.results",
    path: `${APP_PREFIX_PATH}/modules/lab/results/:id`,
    component: React.lazy(() => import("views/app-views/apps/labs/category/LabResultForm")),
  },
  {
    key: "modules.labs.histology.grossing",
    path: `${APP_PREFIX_PATH}/modules/lab/histology/:id`,
    component: React.lazy(() => import("views/app-views/apps/labs/category/histology/grossing")),
  },
  {
    key: "modules.labs.histology.review",
    path: `${APP_PREFIX_PATH}/modules/lab/histology/review/:id`,
    component: React.lazy(() => import("views/app-views/apps/labs/category/histology/reviewing")),
  },
  {
    key: "modules.labs.histology.report",
    path: `${APP_PREFIX_PATH}/modules/lab/histology/report/:id`,
    component: React.lazy(() => import("views/app-views/apps/labs/category/histology/report")),
  },
  {
    key: "modules.labs.report",
    path: `${APP_PREFIX_PATH}/modules/labs/report`,
    component: React.lazy(() => import("views/app-views/apps/labs")),
  },
  {
    key: "modules.labs.intergrations",
    path: `${APP_PREFIX_PATH}/modules/labs/intergrations`,
    component: React.lazy(() => import("views/app-views/apps/machines")),
  },
  {
    key: "modules.labs.daily-availability",
    path: `${APP_PREFIX_PATH}/daily-availability`,
    component: React.lazy(() => import("views/app-views/apps/labs/DailyAvailability")),
  },
  {
    key: "modules.labs.monthly-report",
    path: `${APP_PREFIX_PATH}/modules/labs/monthly-report`,
    component: React.lazy(() => import("views/app-views/apps/reports/")),
  },
  {
    key: "modules.labs.monthly-report",
    path: `${APP_PREFIX_PATH}/modules/labs/tat-report`,
    component: React.lazy(() => import("views/app-views/apps/reports/tat")),
  },
  {
    key: "modules.labs.lab-test-report",
    path: `${APP_PREFIX_PATH}/modules/labs/lab-test-report`,
    component: React.lazy(() => import("views/app-views/apps/reports/lab-test-report")),
  },
  {
    key: "modules.settings.profile",
    path: `${APP_PREFIX_PATH}/settings/profile`,
    component: React.lazy(() => import("views/app-views/user/profile")),
  },
  {
    key: "modules.settings.manage-profile",
    path: `${APP_PREFIX_PATH}/settings/profile/:id`,
    component: React.lazy(() => import("views/app-views/user/manageUser")),
  },
  {
    key: "modules.settings.user-list",
    path: `${APP_PREFIX_PATH}/settings/user-list`,
    component: React.lazy(() => import("views/app-views/user/user-list")),
  },
  {
    key: "forgot-password",
    path: `${APP_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "pages.profile",
    path: `${APP_PREFIX_PATH}/pages/profile`,
    component: React.lazy(() => import("views/app-views/user/profile")),
  },
  {
    key: "pages.user-list",
    path: `${APP_PREFIX_PATH}/pages/user-list`,
    component: React.lazy(() => import("views/app-views/user/user-list")),
  },

];
